import Header from "../components/layout/Header";

const Profile = () => {
  const token = localStorage.getItem("token");
  const userRaw = localStorage.getItem("user");
  let user = {};
  let tokenInfo = {};

  try {
    user = JSON.parse(userRaw);
    if (token) {
      const payload = JSON.parse(atob(token.split(".")[1]));
      tokenInfo = {
        exp: new Date(payload.exp * 1000).toLocaleString(),
        email: payload.email,
      };
    }
  } catch (e) {
    console.error("Error parsing profile data:", e);
  }

  return (
    <div>
      <Header noconsole />
      <div className="max-w-5xl mx-auto px-6 py-12">
        <div className="bg-white shadow rounded-lg p-6 space-y-4">
          <h2 className="text-xl font-semibold text-gray-800">Profile</h2>
          <div>
            <strong>Email:</strong> {user?.email || tokenInfo.email}
          </div>
          <div>
            <strong>Account Type:</strong> {user?.account_type || "Unknown"}
          </div>
          <div>
            <strong>Token Expiry:</strong> {tokenInfo.exp || "Unavailable"}
          </div>
        </div>
        <div className="bg-white shadow rounded-lg p-6 space-y-4 mt-8">
          <h2 className="text-xl font-semibold text-gray-800">Subscription</h2>
          <div>
            <strong>Plan:</strong> Unsubscribed
          </div>
          <div>
            <strong>Next Renewal:</strong> -
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
